/**
 * Frontend JavaScript for the Collaborators block.
 */

document.addEventListener('DOMContentLoaded', function() {
  // Find all collaborator links
  const collaboratorLinks = document.querySelectorAll('.wp-block-collaborator__link');

  // Add smooth scrolling to the collaborator links
  collaboratorLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        // Smooth scroll to the target
        window.scrollTo({
          top: targetElement.offsetTop - 80, // Offset for fixed headers
          behavior: 'smooth',
        });

        // Add a highlight effect
        targetElement.classList.add('highlight');
        setTimeout(() => {
          targetElement.classList.remove('highlight');
        }, 1500);
      }
    });
  });
});

// Add a class to style for highlight effect with CSS
document.head.insertAdjacentHTML('beforeend', `
  <style>
    .wp-block-collaborator__wrapper.highlight {
      animation: highlight-pulse 1.5s ease-out;
    }
    
    @keyframes highlight-pulse {
      0% { box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1); }
      70% { box-shadow: 0 0 0 10px rgba(0, 0, 0, 0); }
      100% { box-shadow: 0 0 0 0 rgba(0, 0, 0, 0); }
    }
  </style>
`);
